import ScreeningDataInfo from "./ScreeningDataInfo";
export default ScreeningDataInfo;
